module.exports = __webpack_public_path__ + "817294527492256ad4ba4294376b947b.svg";